const validator = (properties: Record<string, any>) => {
  const errors: string[] = [];

  if (!properties.delimiter) {
    errors.push('Delimiter is required');
  }

  return errors.length > 0 ? errors : null;
};

export default validator;
